import bankingSystem_0 from "../../images/projects/bankingSystem/0.PNG";
import bankingSystem_1 from "../../images/projects/bankingSystem/1.PNG";
import bankingSystem_2 from "../../images/projects/bankingSystem/2.PNG";
import bankingSystem_3 from "../../images/projects/bankingSystem/3.PNG";
import bankingSystem_4 from "../../images/projects/bankingSystem/4.PNG";
import bankingSystem_5 from "../../images/projects/bankingSystem/5.PNG";
import bankingSystem_6 from "../../images/projects/bankingSystem/6.PNG";
import bankingSystem_7 from "../../images/projects/bankingSystem/7.PNG";
import bankingSystem_8 from "../../images/projects/bankingSystem/8.PNG";

export default function bankingSystemImages() {
  return [
    bankingSystem_0,
    bankingSystem_1,
    bankingSystem_2,
    bankingSystem_3,
    bankingSystem_4,
    bankingSystem_5,
    bankingSystem_6,
    bankingSystem_7,
    bankingSystem_8,
  ];
}